import { Host, h } from '@stencil/core';
export class AibaQuizScreen {
  constructor() {
    this.getData = undefined;
    this.handlers = undefined;
    this.data = undefined;
    this.quiz = undefined;
    this.intro = undefined;
    this.showQuiz = undefined;
    this.showIntro = undefined;
    this.quizIndex = undefined;
    this.triggerRender = undefined;
    this.prevQuizIndex = undefined;
    this.selectedOptions = undefined;
    this.selectedOptionsWithId = undefined;
    this.quizPlainIndex = 0;
    this.totalQuestions = 0;
    this.ModifiedQuizIndex = undefined;
    this.introClasses = undefined;
    this.hideNextButton = undefined;
    this.classes = undefined;
    this.styles = undefined;
    this.singleScreen = false;
    this.showBannerImg = false;
  }
  async componentWillLoad() {
    if (this.getData) {
      const mainData = await this.getData();
      this.data = mainData === null || mainData === void 0 ? void 0 : mainData.data;
      this.classes = mainData === null || mainData === void 0 ? void 0 : mainData.classes;
      this.styles = mainData === null || mainData === void 0 ? void 0 : mainData.styles;
    }
  }
  handleTrigger() {
    this.triggerRender = !this.triggerRender;
  }
  async componentWillRender() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
    if (this.handlers && this.handlers.handleQuizScreenOnLoad) {
      this.totalQuestions = 0;
      for (let i = 0; i < ((_a = this.data) === null || _a === void 0 ? void 0 : _a.length); i++) {
        const questions = (_d = (_c = (_b = this.data[i].data) === null || _b === void 0 ? void 0 : _b.quiz) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.questions;
        this.totalQuestions += questions === null || questions === void 0 ? void 0 : questions.length;
      }
      const { showIntro, showQuiz, currentQuizIndex, currentIntroIndex, selectedOptions, quizPlainIndex, totalQuestions, ModifiedQuizIndex, selectedOptionsWithId = {}, data = {}, hideNextButton, } = await this.handlers.handleQuizScreenOnLoad({
        event: {},
        data: this.data,
      });
      if (data && Object.keys(data).length > 0) {
        this.data = data;
      }
      if (ModifiedQuizIndex) {
        this.ModifiedQuizIndex = ModifiedQuizIndex;
      }
      if (totalQuestions) {
        this.totalQuestions = totalQuestions;
      }
      this.intro = (_f = (_e = this.data[currentIntroIndex]) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.groupIntro;
      this.introClasses = (_g = this.data[currentIntroIndex]) === null || _g === void 0 ? void 0 : _g.classes;
      this.quiz = (_j = (_h = this.data[currentIntroIndex]) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.quiz;
      this.prevQuizIndex = this.quizIndex;
      this.quizIndex = currentQuizIndex;
      this.quizPlainIndex = quizPlainIndex;
      this.showIntro = showIntro;
      this.showQuiz = showQuiz;
      this.selectedOptionsWithId = selectedOptionsWithId ? selectedOptionsWithId : {};
      this.selectedOptions = selectedOptions[this.quizPlainIndex] ? selectedOptions[this.quizPlainIndex] : [];
      this.hideNextButton = hideNextButton ? hideNextButton : '';
      this.singleScreen = ((_o = (_m = (_l = (_k = this.data[currentIntroIndex]) === null || _k === void 0 ? void 0 : _k.data) === null || _l === void 0 ? void 0 : _l.quiz) === null || _m === void 0 ? void 0 : _m.data) === null || _o === void 0 ? void 0 : _o.singleScreen) ? (_s = (_r = (_q = (_p = this.data[currentIntroIndex]) === null || _p === void 0 ? void 0 : _p.data) === null || _q === void 0 ? void 0 : _q.quiz) === null || _r === void 0 ? void 0 : _r.data) === null || _s === void 0 ? void 0 : _s.singleScreen : 'false';
      this.showBannerImg =
        (showIntro && ((_u = (_t = this.data[currentIntroIndex]) === null || _t === void 0 ? void 0 : _t.data) === null || _u === void 0 ? void 0 : _u.groupImg) ? (_w = (_v = this.data[currentIntroIndex]) === null || _v === void 0 ? void 0 : _v.data) === null || _w === void 0 ? void 0 : _w.groupImg : '') ||
          (showQuiz && ((_1 = (_0 = (_z = (_y = (_x = this.data[currentIntroIndex]) === null || _x === void 0 ? void 0 : _x.data) === null || _y === void 0 ? void 0 : _y.quiz) === null || _z === void 0 ? void 0 : _z.data) === null || _0 === void 0 ? void 0 : _0.questions[currentQuizIndex]) === null || _1 === void 0 ? void 0 : _1.questionImg)
            ? (_6 = (_5 = (_4 = (_3 = (_2 = this.data[currentIntroIndex]) === null || _2 === void 0 ? void 0 : _2.data) === null || _3 === void 0 ? void 0 : _3.quiz) === null || _4 === void 0 ? void 0 : _4.data) === null || _5 === void 0 ? void 0 : _5.questions[currentQuizIndex]) === null || _6 === void 0 ? void 0 : _6.questionImg
            : '');
    }
  }
  async componentDidRender() {
    this.handlers && this.handlers.handleQuizScreenDidRender && this.handlers.handleQuizScreenDidRender();
  }
  render() {
    var _a, _b;
    return (h(Host, null, this.styles && h("style", null, this.styles), h("div", { class: "quiz-screen-grid-container" }, this.showBannerImg && (h("div", { class: 'side-banner' }, h("aiba-hero-image", Object.assign({}, this.showBannerImg['data'])))), this.showIntro && this.intro && (h("aiba-quiz-intro", { data: (_a = this.intro) === null || _a === void 0 ? void 0 : _a.data, handleClick: (event, _id) => this.handlers && this.handlers.handleQuizIntroCTAClick && this.handlers.handleQuizIntroCTAClick(event, _id), handlers: this.handlers })), this.showQuiz && (h("aiba-quiz", { data: (_b = this.quiz) === null || _b === void 0 ? void 0 : _b.data, handlers: this.handlers, index: this.quizIndex, selectedOptions: this.selectedOptions, quizPlainIndex: this.ModifiedQuizIndex ? this.ModifiedQuizIndex : this.quizPlainIndex + 1, totalQuestions: this.totalQuestions, selectedOptionsWithId: this.selectedOptionsWithId, hideNextButton: this.hideNextButton })))));
  }
  static get is() { return "aiba-quiz-screen"; }
  static get properties() {
    return {
      "getData": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "get-data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "data": {},
      "quiz": {},
      "intro": {},
      "showQuiz": {},
      "showIntro": {},
      "quizIndex": {},
      "triggerRender": {},
      "prevQuizIndex": {},
      "selectedOptions": {},
      "selectedOptionsWithId": {},
      "quizPlainIndex": {},
      "totalQuestions": {},
      "ModifiedQuizIndex": {},
      "introClasses": {},
      "hideNextButton": {},
      "classes": {},
      "styles": {},
      "singleScreen": {},
      "showBannerImg": {}
    };
  }
  static get listeners() {
    return [{
        "name": "event-quizscreen",
        "method": "handleTrigger",
        "target": "window",
        "capture": true,
        "passive": false
      }];
  }
}
//# sourceMappingURL=aiba-quiz-screen.js.map
